<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1>Blogs List</h1>
          <b-table
            class="position-relative"
            :items="blogsList"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="No Blogs were found"
          >
            <!-- eslint-disable-next-line -->
            <template #cell(cover)="data">
              <b-media vertical-align="center">
                <b-avatar
                    rounded
                    size="100"
                    :src="`${baseUrl}/${data.item.imageUrl}`"
                    :variant="`success`"
                />
              </b-media>
            </template>

            <template #cell(actions)="data">
              <add-edit-delete-button
                :data="generateObjectForAddEditRemoveButton(data.item)"
                :languageList="languageList"
                :routerEditName="'pages-blog-edit'"
                :routerCreateName="'pages-posts-create'"
                @renderDeleteModal="renderDeleteModal"
              ></add-edit-delete-button>
              <!-- <div
                class="d-flex align-items-center justify-content-between"
                style="gap: 2rem"
              >
                <router-link :to="`/pages/blog/${data.item.id}`">
                  <feather-icon
                    size="20"
                    icon="EditIcon"
                    style="cursor: pointer"
                    class="text-primary"
                  />
                </router-link>
                <b-link
                  class="d-flex flex-column justify-content-center align-align-items-center"
                  :to="{
                    name: 'pages-posts-create',
                    params: { langId: 1, mainId: data.item.mainId },
                    query: {
                      lang: 'انگلیسی',
                      title: data.item.title,
                      link: data.item.seourl,
                    },
                  }"
                >
                  <b-img height="12px" width="18px" src="/en-flag.png" />
                  <span style="font-size: 10px; margin-top: 2px">SET</span>
                </b-link>
                <b-button
                  variant="transparent"
                  @click="renderDeleteModal(data.item)"
                >
                  <feather-icon
                    size="20"
                    icon="Trash2Icon"
                    class="text-danger"
                  ></feather-icon>
                </b-button>
              </div> -->
            </template>
            <template #cell(status)="data">
              {{ blogStatuses[data.item.status] }}
            </template>
          </b-table>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center py-2"
          >
            <b-pagination
              v-model="pageNumber"
              :total-rows="totalCount"
              :per-page="count"
              first-number
              last-number
              class="mb-0 mt-1"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="delete-modal"
      ok-variant="danger"
      title="Delete News"
      ok-title="Yes"
      cancel-title="Dismiss"
      centered
      @ok="sendDeleteRequest"
    >
      <template v-if="tempBlog">
        <span>Are you sure you want to delete news?</span>
      </template>
    </b-modal>
  </b-overlay>
</template>

<script>
import { GetAllBlogs, BlogDeleteRequest } from "@/libs/Api/Blog";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AddEditDeleteButton from "@/views/components/utils/AddEditDeleteButton.vue";

export default {
  title: "Blogs List",
  mounted() {
    this.getAllBlogsList();
    this.getAllLanguages();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllBlogsList();
      },
    },
  },
  data() {
    return {
      baseUrl:Helper.baseUrl,
      languageList:[],
      isLoading: false,
      count: 10,
      pageNumber: 1,
      totalCount: null,
      categoryName: null,
      tagId: null,
      searchByTitle: null,
      date: null,
      blogsList: null,
      blogStatuses: {
        1: "Published",
        2: "Archived",
      },
      myTableColumns: [
        {
          key: "cover",
          label: "Cover",
        },
        {
          key: "title",
          label: "Blog Title",
        },
        {
          key: "status",
          label: "Blog Status",
        },
        {
          key: "userInfo.fullName",
          label: "Author",
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],
      tempBlog: null,
    };
  },
  methods: {
    async getAllLanguages() {
      try {
        let requestParams = {
          count: 100,
          pageNumber: 1,
        };
        if (this.searchCommand) {
          requestParams["searchCommand"] = this.searchCommand;
        }
        this.isLoading = true;
        let _this = this;
        let getAllLangs = new GetAllLangs(_this);

        getAllLangs.setRequestParam(requestParams);
        await getAllLangs.fetch((response) => {
          if (response.isSuccess) {
            _this.languageList = response.data.languages;
            // _this.totalCount = response.data.languagesCount;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    generateObjectForAddEditRemoveButton(blogDetails) {
      return {
        id: blogDetails.id,
        languageId: blogDetails.languageId,
        otherLanguages: blogDetails.otherLanguages || [],
        mainId: blogDetails.mainId,
      };
    },
    renderDeleteModal(blog) {
      this.tempBlog = JSON.parse(JSON.stringify(blog));
      this.$bvModal.show("delete-modal");
    },
    async sendDeleteRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let blogDeleteRequest = new BlogDeleteRequest(_this);
        blogDeleteRequest.setId(_this.tempBlog.id);
        await blogDeleteRequest.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "Operation Was Successful",
                icon: "Trash2Icon",
                variant: "success",
                text: "News Deleted Successfully",
              },
            });
            _this.getAllBlogsList();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllBlogsList() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllBlogs = new GetAllBlogs(_this);
        let qParams = {
          count: _this.count,
          pageNumber: _this.pageNumber,
          languageId:1,
        };
        if (this.categoryName) {
          qParams["categoryName"] = this.categoryName;
        }
        if (this.tagId) {
          qParams["tagId"] = this.tagId;
        }
        if (this.searchByTitle) {
          qParams["searchByTitle"] = this.searchByTitle;
        }
        if (this.date) {
          qParams["date"] = this.date;
        }
        getAllBlogs.setRequestParam(qParams);
        await getAllBlogs.fetch((response) => {
          if (response.isSuccess) {
            _this.blogsList = response.data.data;
            _this.totalCount = response.data.totalCount;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BFormRow,
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BTable,
    BImg,
    BMedia,
    BAvatar,
    BModal,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    AddEditDeleteButton,
  },
};
import {
  BContainer,
  BCard,
  BRow,
  BFormRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BTable,
  BImg,
  BMedia,
  BAvatar,
  BModal,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import {GetAllLangs} from "@/libs/Api/Language";
import Helper from "@/libs/Helper";
</script>
